import type { Card } from '../../types';

export const SHIELD_UP: Card = {
  id: 'shield-up',
  name: 'Shield Up',
  type: 'defense',
  rarity: 'common',
  size: { w: 1, h: 2 },
  cost: [{ kind: 'min', value: 3 }],
  effects: [{ kind: 'block', amount: 5 }],
};
